/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RelatedItemListContent_data = {
    readonly items: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly slug: string;
                readonly " $fragmentRefs": FragmentRefs<"ShowPageListItem_listItem">;
            } | null;
        } | null> | null;
    };
    readonly downloadToken: string;
    readonly " $refType": "RelatedItemListContent_data";
};
export type RelatedItemListContent_data$data = RelatedItemListContent_data;
export type RelatedItemListContent_data$key = {
    readonly " $data"?: RelatedItemListContent_data$data;
    readonly " $fragmentRefs": FragmentRefs<"RelatedItemListContent_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RelatedItemListContent_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ListItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ListItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ListItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ShowPageListItem_listItem"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadToken",
      "storageKey": null
    }
  ],
  "type": "ItemList",
  "abstractKey": null
};
(node as any).hash = '580a22c33d09b648a95e96a190a359d3';
export default node;
